import "owl.carousel2";
import "owlcarousel2-filter";

export default {
    init() {

    },
    finalize() {

    },
    onLoad() {

        /* JS INIZIALIZZAZIONE OWLCAROUSEL ARTICOLI CORRELATI */
        /* STESSO CODICE PER FILE FLEX-SLIDER-ARTICOLI-CORRELATI.BLADE.PHP */
        let sliderSingleArticoliCorrelati = $(".container-single-slider-articoli-correlati .correlati-slider");
        if (sliderSingleArticoliCorrelati.length > 0) {
            $.slidersliderSingleArticoliCorrelati = sliderSingleArticoliCorrelati.owlCarousel({
                loop: false,
                nav: true,
                navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
                dots: false,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                responsive: {
                    0: {
                        items: 2,
                        margin: 10,
                    },
                    576: {
                        items: 2,
                        margin: 60,
                    },
                    991: {
                        items: 3,
                        margin: 60,
                    },
                    1200: {
                        items: 4,
                        margin: 100,
                    },
                },
            });

            // Filter slider post
            $(".slider-post.filter-value").each(function () {
                if (!$(this).hasClass("active")) {
                    let cat = "." + $(this).data("value");
                    let isPresent = $(".single" + cat).length;
                    $(this).on("click", function () {
                        $(".slider-post.filter-value").removeClass("active");
                        $(".slider-post.filter-reset").addClass("disabled").removeClass("active");
                        $(this).addClass("active");

                        let cat = $(this).data("value");
                        let slider = $(".correlati-slider");
                        slider.addClass("hide");
                        slider.on("transitionend", function () {
                            $.slidersliderSingleArticoliCorrelati.owlcarousel2_filter("." + cat);
                            $(this).off("transitionend");
                            $(this).removeClass("hide");
                        });
                    });
                    if (isPresent <= 0) {
                        $(this).css("display", "none");
                    }
                }
            });

            $(".slider-post.filter-reset").on("click", function () {
                if (!$(this).hasClass("active")) {
                    $(".slider-post.filter-value").removeClass("active");
                    $(".slider-post.filter-reset").removeClass("disabled");
                    $(this).addClass("active");

                    let slider = $(".correlati-slider");
                    slider.addClass("hide");
                    slider.on("transitionend", function () {
                        $.slidersliderSingleArticoliCorrelati.owlcarousel2_filter("*");
                        $(this).off("transitionend");
                        $(this).removeClass("hide");
                    });
                }
            });
        }
    },
    onResize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js